<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <div class="spacer">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1000 36">
            <defs>
                <linearGradient id="Line-grd" x1="0" y1="54.25" x2="1000" y2="54.25" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="currentColor" stop-opacity="0" />
                    <stop offset=".5" stop-color="currentColor" />
                    <stop offset="1" stop-color="currentColor" stop-opacity="0" />
                </linearGradient>
                <clipPath id="clippath">
                    <rect fill="none" x="0" y="1" width="1000" height="54" />
                </clipPath>
                <filter id="blur-effect" x="0" y="0" width="200%" height="200%">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
                </filter>
            </defs>
            <g>
                <line x1="0" y1="0" x2="1000" y2="1" stroke="url(#Line-grd)" stroke-miterlimit="10" />
                <ellipse clip-path="url(#clippath)" cx="500" cy="1" rx="400" ry="18" fill="currentColor"
                    filter="url(#blur-effect)" />
            </g>
        </svg>
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="sass">
svg
    @apply text-orange

    line
        @apply opacity-50

    ellipse
        @apply opacity-10
</style>